import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { DataTable } from '@/components/ui/data.table/data-table';

import { dueOrdersColumns } from './column';
import { useWholesaleCustomerDetails } from './hook';

export const DueOrders = () => {
    const { dueOrders, isLoadingOrders, isErrorOrders } =
        useWholesaleCustomerDetails();

    const renderDataTable = () => {
        if (isLoadingOrders) {
            return <p>Loading...</p>;
        }

        if (isErrorOrders) {
            return <p>Error loading due orders</p>;
        }

        if (dueOrders && dueOrders.data.length > 0) {
            return (
                <DataTable columns={dueOrdersColumns} data={dueOrders.data} />
            );
        }
        return <p>No due orders found.</p>;
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle>Due Orders</CardTitle>
            </CardHeader>
            <CardContent>{renderDataTable()}</CardContent>
        </Card>
    );
};
